module.exports = __webpack_public_path__ + "media/images/coffee-52b9b1d19861fbb9d31c952d55298cda.png";